import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PortfolioItem from './PortfolioItem';
import Seo from './Seo';
import portfolioData from '../data/portfolioItems.json';

const Work: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the '#' from the hash
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        // Scroll to the element with smooth behavior
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <main>
      <Seo
        title="Our Work — HICO Web & Ecommerce Projects"
        description="Selected websites and ecommerce projects by HICO, including work for American Forests, the ESA, Card Vault by Tom Brady, and more."
        path="/work"
      />
      <div>
        <div><h1 className="pageTitle">Explore some of our work</h1> </div>
        <section id="portfolio">
          {portfolioData.map((project) => (
            <PortfolioItem
              key={project.id}
              project={project}
            />
          ))}
        </section>
      </div>
    </main>
  );
};

export default Work;